import React, { useEffect, useState } from 'react';
import { Button, Icon, Message } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../AuthHooks';
import { SetLoading } from '@arema/components/Classes';

interface LoginSavedProps{
	
}

var LoginSaved = (props: LoginSavedProps)=>{
	var { user, clearSaved, loginSaved, params, getContinueUrl } = useAuth();
	var { t } = useTranslation();
	var [prompts, setPrompts] = useState<string>(null);
	useEffect(()=>{
		
	}, []);

	var login = (setLoading: SetLoading)=>{
		setLoading(true);
		setPrompts(null);
		loginSaved().then(res=>{
			if(res.error) return setPrompts(res.message);
			if(params.continue_url){
				setTimeout(()=>{
					var url = getContinueUrl(res.data.tokens);;
					if(!url) return;
					window.location.href = url;
				}, 1000);
			}
		}).finally(()=>{
			setLoading(false)
		}).catch(err=>{});
	}
	
	return <div className="ar logged-screen">
		<Icon name='user-circle' />
		<div className="name">
			{user.user.first_name} {user.user.last_name}
		</div>
		<div className="subname">
			{t('login.saved_session')}
		</div>
		{!!prompts && (
			<Message text={prompts} type='error' />
		)}
		<div className="actions">
			<Button text={t('common.login')} color='orange' onClick={login} />
			<Button text={t('common.logout')} color='black' size='tiny' basic style={{ marginTop: 5 }} onClick={clearSaved} />
		</div>
	</div>
}

export default LoginSaved;